// extracted by mini-css-extract-plugin
export default {"backDrop":"WarningBox_backDrop__CwBIq","infoBox":"WarningBox_infoBox__LRFQf","gotItbtn":"WarningBox_gotItbtn__dRWCp"};